import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const Header = ({ icon, title, hasButton, dependency, path, name }) => {
  return (
    <div className="row justify-content-between align-items-center underline my-2">
      <div className="col-md-6 mt-2">
        <h2>
          <i className={icon}></i> {title}
        </h2>
      </div>
      <div className="col-sm-12 col-md-5 col-lg-4 col-xl-3 mb-2 text-end">
        {hasButton && (
          <Link
            className={
              dependency && dependency.length === 0
                ? "btn btn-theme btn-block rounded disabled"
                : "btn btn-theme btn-block rounded"
            }
            to={path}
            aria-disabled={true}
          >
            <i className="fa fa-plus-circle" aria-hidden="true"></i> {name}
          </Link>
        )}
      </div>
    </div>
  );
};

// Typechecking
Header.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  hasButton: PropTypes.bool.isRequired,
  dependency: PropTypes.array,
  path: PropTypes.string,
  name: PropTypes.string,
};

export default Header;
